export enum ErrorCode {
  DOCUMENT_IS_EMPTY = 'DOCUMENT_IS_EMPTY',
  DOCUMENT_TOO_LONG = 'DOCUMENT_TOO_LONG',
  RETRY_LIMIT_REACHED = 'RETRY_LIMIT_REACHED',
  UNKNOWN = 'UNKNOWN'
}

interface ErrorTranslation {
  title: string;
  body: string;
}

export class ErrorUtils {
  private static readonly ERROR_TRANSLATION_MAP: Record<ErrorCode, string> = {
    [ErrorCode.DOCUMENT_IS_EMPTY]: 'document_empty',
    [ErrorCode.DOCUMENT_TOO_LONG]: 'document_too_long',
    [ErrorCode.RETRY_LIMIT_REACHED]: 'retry_limit',
    [ErrorCode.UNKNOWN]: 'unknown'
  };

  public static toTranslationKey(errorCode: string | unknown): string {
    if (typeof errorCode !== 'string') errorCode = errorCode?.toString();

    switch (errorCode) {
      case ErrorCode.DOCUMENT_IS_EMPTY:
        return ErrorUtils.ERROR_TRANSLATION_MAP[ErrorCode.DOCUMENT_IS_EMPTY];
      case ErrorCode.DOCUMENT_TOO_LONG:
        return ErrorUtils.ERROR_TRANSLATION_MAP[ErrorCode.DOCUMENT_TOO_LONG];
      case ErrorCode.RETRY_LIMIT_REACHED:
        return ErrorUtils.ERROR_TRANSLATION_MAP[ErrorCode.RETRY_LIMIT_REACHED];
      default:
        return ErrorUtils.ERROR_TRANSLATION_MAP[ErrorCode.UNKNOWN];
    }
  }

  public static getTranslatedError(
    errorCode: string | unknown,
    t: (key: string, values?: Record<string, unknown>) => string
  ): ErrorTranslation {
    const translationKey = ErrorUtils.toTranslationKey(errorCode);

    return {
      title: t(`contextual_errors.${translationKey}.title`),
      body: t(`contextual_errors.${translationKey}.body`)
    };
  }
}
